import { render } from "./SinistroPagamentoDetalheView.vue?vue&type=template&id=e01e2160&scoped=true"
import script from "./SinistroPagamentoDetalheView.vue?vue&type=script&lang=js"
export * from "./SinistroPagamentoDetalheView.vue?vue&type=script&lang=js"

import "./SinistroPagamentoDetalheView.vue?vue&type=style&index=0&id=e01e2160&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e01e2160"]])

export default __exports__